import * as zoid from 'zoid/dist/zoid.frameworks'

// Admin-app zoid mount for the team-management embed (CS view).
//
// Tag and prop schema are kept in lockstep with the embed's in-house
// definition at packages/frontend/src/host/teamAppZoid.ts in the
// aha-team-management repo. The team app owns its zoid contract — this
// file mirrors it on the admin-app side so zoid can wire the iframe.
//
// We reuse the same tag as the presenter (`team-app-iframe`); zoid keys
// on the tag, so registering it here is what lets the iframe handshake
// complete against the embed's `initializeTeamApp()` call.
const TeamAppIframe = zoid.create({
  tag: 'team-app-iframe',
  url: ({ props }) => props.url,
  attributes: {
    iframe: {
      allow: 'clipboard-write *; clipboard-read *',
    },
  },
  props: {
    url: { type: 'string', required: true, queryParam: false },
    token: { type: 'string', required: false, queryParam: false },
    currentUser: { type: 'object', required: false, queryParam: false },
    currentLanguage: { type: 'string', required: false, queryParam: false },
    showToastSuccess: { type: 'function', required: false },
    showToastError: { type: 'function', required: false },
    showToastInfo: { type: 'function', required: false },
    showConfirmModal: { type: 'function', required: false },
    trackGA4AndMixpanel: { type: 'function', required: false },
    onRouteChange: { type: 'function', required: false },
    onHeightChange: { type: 'function', required: false },
    executeRecaptcha: { type: 'function', required: false },
    openRequestAdditionalLicenseModal: { type: 'function', required: false },
    scimEnabled: { type: 'boolean', required: false, queryParam: false },
    featureFlags: { type: 'object', required: false, queryParam: false },
  },
})

export default TeamAppIframe
